import React from 'react';
import ComplaintCard from './CallbackCard';

interface IProps {
  callbacks: any;
  selectedCallbackInfo: any;
  setSelectedCallbackInfo: any;
}

const ListOfComplaints = (props: IProps) => {
  const { callbacks, selectedCallbackInfo, setSelectedCallbackInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {callbacks.map((info: any, index: number) => (
        <ComplaintCard
          info={info}
          selectedCallbackInfo={selectedCallbackInfo}
          setSelectedCallbackInfo={setSelectedCallbackInfo}
          key={index}
        />
      ))}
    </div>
  );
};

export default ListOfComplaints;
